export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'jobs.delete_merchantgroup',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:jobs:merchantgroup:export',
    },
  },
}